const testimonialsSections = document?.querySelectorAll(
  ".testimonials-slider-section"
);

const videoModal = document?.querySelector("#vimeo-video-modal");
const videoModalContent = videoModal?.querySelector(".video-modal");
const closeVideoModal = videoModal?.querySelector(".close-modal");
const videoIframe = videoModal?.querySelector("iframe");

closeVideoModal?.addEventListener("click", function () {
  videoModal?.classList?.remove("active");
  videoIframe.src = "";
  document.body.style.overflow = "auto";
});

videoModal?.addEventListener("click", function () {
  videoModal?.classList?.remove("active");
  videoIframe.src = "";
  document.body.style.overflow = "auto";
});
videoModalContent?.addEventListener("click", function (e) {
  e?.stopPropagation();
});

testimonialsSections?.forEach((item) => {
  const sliderEl = item?.querySelector(".keen-slider");

  if (sliderEl) {
    const slider = new KeenSlider(sliderEl, {
      breakpoints: {
        "(max-width: 500px)": {
          slides: { perView: 1.3, spacing: 20 },
        },
      },
      slides: {
        perView: "auto",
        spacing: 35,
      },
    });
    const nextBtn = item?.querySelector(".next-btn");
    const prevBtn = item?.querySelector(".prev-btn");
    nextBtn?.addEventListener("click", function () {
      slider?.next();
    });
    prevBtn?.addEventListener("click", function () {
      slider?.prev();
    });
  }

  const videosWrappers = item?.querySelectorAll(".video-wrapper");
  videosWrappers?.forEach((i) => {
    const videoOverlay = i?.querySelector(".video-overlay");

    videoOverlay?.addEventListener("click", function () {
      const videoId = i?.dataset?.videoId;

      if (videoModal && videoId) {
        videoIframe.src = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
        videoModal?.classList?.add("active");
        document.body.style.overflow = "hidden";
      }
    });
  });
});
